import styled, { css } from 'styled-components';
import { variant } from '../../../../../helpers/styledComponents';

export const StyledFilterPill = styled.div<{
  appearance: 'primary' | 'secondary';
  removeIconPosition: 'left' | 'right';
}>`
  ${variant(
    {
      primary: css`
        background: ${props => props.theme.color.monochrome1.default};

      `,
      secondary: css`
        background: ${props => props.theme.color.monochrome2.default};
      `,
    },
    'appearance'
  )}

  border-radius: 1.875rem;
  padding: 0.5625rem 1rem;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;

  .icon {
    cursor: pointer;
    display: flex;
    align-items: center;

    ${props =>
      props.removeIconPosition === 'right' &&
      css`
        order: 1;
      `};
  }

  .displayName {
    order: 0;
  }
`;
